import { Modal, } from 'reactstrap'
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Controller } from 'react-hook-form'
 import {
  SPLIT_CASE_CONDITION_FULL,
  SPLIT_CASE_CONDITION_PARTIAL
 } from '_utils/constant'
import InputProduct from './InputProduct'

const SplitCaseModal = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { isOpen, toggle, onOk, register, productIndex, errors, watch, setValue, control } = props
  const price = watch(`products.${productIndex}.price`)
  const itemsPerCase = watch(`products.${productIndex}.splitCasePurchase.itemsPerCase`)

  const fulfillCondition = watch(`products.${productIndex}.splitCasePurchase.fulfillCondition`)

  useEffect(() => {
    if (!fulfillCondition) {
      setValue(
        `products.${productIndex}.splitCasePurchase.fulfillCondition`,
        SPLIT_CASE_CONDITION_FULL
      )
    }
  }, [fulfillCondition, productIndex, setValue])

  const isError = !!errors?.products
  const location = useLocation()
  const [hideCheckbox, setHideCheckbox] = useState(false)
  const [isCostPerItemTouched, setIsCostPerItemTouched] = useState(false)
  const showCheckbox = !hideCheckbox && fulfillCondition === SPLIT_CASE_CONDITION_FULL
  useEffect(() => {
    if (isOpen) {
      setIsCostPerItemTouched(false)
    }
  }, [isOpen])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('id')) {
      setHideCheckbox(true)
    } else {
      setHideCheckbox(false)
    }
  }, [location.search])
  useEffect(() => {
    if (fulfillCondition === SPLIT_CASE_CONDITION_FULL) {
      setValue(`products.${productIndex}.splitCasePurchase.acknowledgementRequiredPayAfter`, true)
    } else {
      setValue(`products.${productIndex}.splitCasePurchase.acknowledgementRequiredPayAfter`, false)
    }
  }, [fulfillCondition, productIndex, setValue])

  useEffect(() => {
    if (
      isOpen &&
      !isCostPerItemTouched &&
      itemsPerCase !== undefined &&
      itemsPerCase !== null &&
      itemsPerCase !== '' &&
      !isNaN(Number(itemsPerCase)) &&
      Number(itemsPerCase) > 0 &&
      price !== undefined &&
      price !== null &&
      price !== '' &&
      !isNaN(Number(price)) &&
      Number(price) > 0
    ) {
      const timer = setTimeout(() => {
        const cost = Number(price) / Number(itemsPerCase)
        setValue(`products.${productIndex}.splitCasePurchase.costPerItem`, Number(cost.toFixed(2)))
      }, 1000)

      return () => clearTimeout(timer)
    }
  }, [isOpen, itemsPerCase, price, productIndex, setValue, isCostPerItemTouched])
  useEffect(() => {
    if (isOpen) {
      const minItemOrder = watch(`products.${productIndex}.splitCasePurchase.minItemOrder`)
      if (minItemOrder === undefined || minItemOrder === null || minItemOrder === '') {
        setValue(`products.${productIndex}.splitCasePurchase.minItemOrder`, 1)
      }
    }
  }, [isOpen, productIndex, setValue])
  const handleToggle = () => {
    if (errors && errors?.length > 0 && Object.entries(errors?.products).length !== 0) {
      return
    }
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} centered className='product-setting'>
      <div className='container'>
        <p className='c-txt-org text-center'>Split Case Purchase</p>
        <div className='c-form'>
          <div className='form-group'>
            <div className='row'>
              <label className='col-5 align-self-center'>Items per case/carton:</label>
              <div className='col-7'>
                <InputProduct
                  type='number'
                  className={`form-control split-case ${
                    errors?.products &&
                    Object.entries(errors?.products).length !== 0 &&
                    errors?.products[productIndex]?.splitCasePurchase?.itemsPerCase &&
                    'is-error'
                  }`}
                  register={register(`products.${productIndex}.splitCasePurchase.itemsPerCase`, {
                    setValueAs: (value) => (value === '' ? null : Number(value)),
                    validate: {
                      isNumber: (value) => {
                        if (value === null || value === '') return true // Allow empty
                        return !isNaN(Number(value)) || 'Items per case must be a number'
                      },
                      isPositive: (value) => {
                        if (value === null || value === '') return true
                        return Number(value) > 0 || 'Must be greater than 0'
                      }
                    }
                  })}
                  error={errors?.products?.[productIndex]?.splitCasePurchase?.itemsPerCase?.message}
                />
              </div>
              <label className='col-5 align-self-center'>Cost per item:</label>
              <div className='col-7'>
                <Controller
                  control={control}
                  name={`products.${productIndex}.splitCasePurchase.costPerItem`}
                  render={({ field }) => (
                    <InputProduct
                      {...field}
                      type='number'
                      className={`form-control ${
                        errors?.products?.[productIndex]?.splitCasePurchase?.costPerItem
                          ? 'is-error'
                          : ''
                      }`}
                      value={field.value ?? ''}
                      onChange={(e) => {
                        setIsCostPerItemTouched(true)
                        field.onChange(e)
                        setValue(
                          `products.${productIndex}.splitCasePurchase.costPerItem`,
                          e.target.value === '' ? null : Number(e.target.value)
                        )
                      }}
                      error={
                        errors?.products?.[productIndex]?.splitCasePurchase?.costPerItem?.message
                      }
                    />
                  )}
                />
              </div>
              <label className='col-5 align-self-center'>Minimum item order:</label>
              <div className='col-7'>
                <InputProduct
                  type='number'
                  defaultValue={1}
                  className={`form-control ${
                    errors?.products?.[productIndex]?.splitCasePurchase.minItemOrder
                      ? 'is-error'
                      : ''
                  }`}
                  register={register(`products.${productIndex}.splitCasePurchase.minItemOrder`)}
                  error={errors?.products?.[productIndex]?.splitCasePurchase?.minItemOrder?.message}
                />
              </div>

              <div className='col-12 mt-3'>
                <div className='form-check'>
                  <input
                    type='radio'
                    value={SPLIT_CASE_CONDITION_FULL}
                    defaultChecked={true}
                    className='form-check-input'
                    {...register(`products.${productIndex}.splitCasePurchase.fulfillCondition`, {
                      required: true,
                    })}
                  />
                  <label className='form-check-label'>
                    Fulfill only when a full case is ordered
                  </label>
                </div>
                <div className='form-check'>
                  <input
                    type='radio'
                    value={SPLIT_CASE_CONDITION_PARTIAL}
                    className='form-check-input'
                    {...register(`products.${productIndex}.splitCasePurchase.fulfillCondition`, {
                      required: true,
                    })}
                  />
                  <label className='form-check-label'>Fulfill even if the case is incomplete</label>
                </div>
              </div>
              <div className='col-12'>
                <hr className='my-3 border-dark' />
              </div>
              <div className='d-flex gap-3'>
                {showCheckbox && (
                  <>
                    <input
                      id='autoPaymentAfter'
                      type='checkbox'
                      className='custom-control-checkbox'
                      checked={true}
                      readOnly
                      disabled
                      style={{ pointerEvents: 'none' }}
                    />
                    <label className='custom-control-label' htmlFor='autoPaymentAfter'>
                      I acknowledge that enabling the split case option—fulfilled only when a full
                      case is ordered—will automatically activate the &apos;Pay Later&apos; option.
                    </label>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-6 m-auto'>
            <button
              disabled={isError}
              className='btn btn--org btn--org02'
              onClick={() => {
                if (onOk) onOk()
                else handleToggle()
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default SplitCaseModal
